import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseAiPredictorMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/components/fp-logger-noise-ai-predictor-minimized/fp-logger-noise-ai-predictor-minimized.component';
import { FpLoggerNoiseAiPredictorComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/components/fp-logger-noise-ai-predictor/fp-logger-noise-ai-predictor.component';
import { FpLoggerNoiseAiPredictorActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor/fp-logger-noise-ai-predictor.actions';
import { FpLoggerNoiseAiPredictorStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-ai-predictor/services/fp-logger-noise-ai-predictor/fp-logger-noise-ai-predictor.store';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseAiPredictorConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseAiPredictorStore);
  public currentTab = FpLoggerNoiseTabs.AIPredictor;

  public component: Type<unknown> = FpLoggerNoiseAiPredictorComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseAiPredictorMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseAiPredictorActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseAiPredictorActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
